module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-bookitalic-webfont.f2411b0d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-bookitalic-webfont.ttf
// module id = 359
// module chunks = 3